import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const DevAuthContext = createContext(null);

export function DevAuthProvider({ children }) {
  // null = checking, false = anonymous (or marketplace off), object = developer
  const [dev, setDev] = useState(null);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/dev/auth/me");
      setDev(data);
      return data;
    } catch {
      setDev(false);
      return false;
    }
  }, []);

  useEffect(() => {
    if (window.location.hash?.includes("session_id=")) return;
    refresh();
  }, [refresh]);

  const enter = async (path, body) => {
    const { data } = await api.post(path, body);
    if (data.admin) return data; // Fabrice's email: admin session, no developer account
    return refresh();
  };

  const logout = async () => {
    try {
      await api.post("/dev/auth/logout");
    } finally {
      setDev(false);
    }
  };

  return (
    <DevAuthContext.Provider value={{ dev, setDev, refresh, enter, logout }}>{children}</DevAuthContext.Provider>
  );
}

export const useDevAuth = () => useContext(DevAuthContext);
